export default "__VITE_ASSET__zYR0PeWT__"